import { OrganizationManagerScreens } from "src/constants/OrganizationManagerScreens"
import { commonHeaderOptions } from "src/constants/options/commonHeaderOptions"
import { OrganizationManagerTab } from "src/screens/bottomTabs/OrganizationManagerTab"
import { OrganizationDetail } from "src/screens/organization/OrganizationDetail"
import { OrganizationGroups } from "src/screens/organization/OrganizationGroups"
import { OrganizationMembers } from "src/screens/organization/OrganizationMembers"

import { OrganizationManagerStackParamList } from "src/types.d"
import { createStackNavigator } from "@react-navigation/stack"
import { CompletedApplyPaid, CompletedApplyPaidOptions } from "src/screens/organization/CompletedApplyPaid"
import OrderDetail, { OrderDetailOptions } from "src/screens/registerPaidTeam/OrderDetail"
import { OrganizationMemberGrade, teamMemberGradeOption } from "src/screens/organization/OrganizationMemberGrade"

export const OrganizationManagerStack = createStackNavigator<OrganizationManagerStackParamList>()

const OrganizationManagerNavigator = () => {
  return (
    <OrganizationManagerStack.Navigator>
      <OrganizationManagerStack.Screen
        name={OrganizationManagerScreens.OrganizationManager}
        component={OrganizationManagerTab}
        options={{ ...commonHeaderOptions, title: "団体管理", headerShown: true, headerLeft: () => null }}
      />
      <OrganizationManagerStack.Screen
        name={OrganizationManagerScreens.OrganizationDetail}
        component={OrganizationDetail}
        options={{ headerShown: false, title: "団体詳細" }}
      />
      <OrganizationManagerStack.Screen
        name={OrganizationManagerScreens.OrganizationMembers}
        component={OrganizationMembers}
        options={{ ...commonHeaderOptions, title: "メンバー一覧", headerShown: true }}
      />
      <OrganizationManagerStack.Screen
        name={OrganizationManagerScreens.OrganizationGroups}
        component={OrganizationGroups}
        options={{ ...commonHeaderOptions, title: "グループ一覧", headerShown: true }}
      />
      <OrganizationManagerStack.Screen
        name={OrganizationManagerScreens.OrganizationMemberGrade}
        component={OrganizationMemberGrade}
        options={teamMemberGradeOption}
      />
      <OrganizationManagerStack.Screen
        name={OrganizationManagerScreens.CompletedApplyPaid}
        component={CompletedApplyPaid}
        options={{ ...CompletedApplyPaidOptions, headerShown: true }}
      />
      <OrganizationManagerStack.Screen
        name={OrganizationManagerScreens.OrderDetail}
        component={OrderDetail}
        options={{ ...OrderDetailOptions, headerShown: true }}
      />
    </OrganizationManagerStack.Navigator>
  )
}

export default OrganizationManagerNavigator
